import styled from 'styled-components';
import { DoubleArrow } from 'ui/icons/navigation/DoubleArrow';
import { DownArrow } from 'ui/icons/navigation/DownArrow';
import { UpArrow } from 'ui/icons/navigation/UpArrow';
import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';

import { spacing, colors, body2 } from 'ui/theme';
import { useSortingContext } from 'utils/contexts/sorting';
import { pxToRem } from 'utils/convert';

const TableHeaderButton = styled.button`
  align-items: center;
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  font-size: ${pxToRem(14)};
  gap: ${spacing.half};
  width: 100%;
  padding: ${spacing.half} 0;
  &:not([data-active='true']) {
    color: ${colors.textPrimary};
  }
  &[data-active='true'] {
    color: ${colors.purple90};
  }
`;

const Label = styled.span`
  ${body2}
  &[data-active='true'] {
    color: ${colors.purple90};
  }
`;

const ARIA_SORT_BY_SORT_DIRECTION: Record<SORT_DIRECTIONS, 'ascending' | 'descending'> = {
  [SORT_DIRECTIONS.ASCENDING]: 'ascending',
  [SORT_DIRECTIONS.DESCENDING]: 'descending',
};

export const SortableHeaderCell = ({ label, name }: { label: string; name: string }) => {
  const { setSortBy, sortBy, sortDirection, setSortDirection } = useSortingContext();

  const isActiveSortColumn = sortBy === name;
  const isAscending = sortDirection === SORT_DIRECTIONS.ASCENDING;

  return (
    <TableHeaderButton
      data-active={isActiveSortColumn}
      role="columnheader"
      aria-sort={isActiveSortColumn ? ARIA_SORT_BY_SORT_DIRECTION[sortDirection] : 'none'}
      onClick={() => {
        if (isActiveSortColumn) {
          setSortDirection(isAscending ? SORT_DIRECTIONS.DESCENDING : SORT_DIRECTIONS.ASCENDING);
        } else {
          setSortBy(name);
          setSortDirection(SORT_DIRECTIONS.ASCENDING);
        }
      }}
    >
      <Label data-active={isActiveSortColumn}>{label}</Label>
      {!isActiveSortColumn && <DoubleArrow isColorInherited />}
      {isActiveSortColumn && isAscending && <UpArrow isColorInherited />}
      {isActiveSortColumn && !isAscending && <DownArrow isColorInherited />}
    </TableHeaderButton>
  );
};
